import { getServiceTrackingUrl } from "../utils/getServiceTrackingUrl";
import { fetchTimeout } from "utils";
import type { FandomLegacyAds } from "common-types";
import { TRACKING_FETCH_TIMEOUT } from "../../consts";
import { shouldSendToEndpoint } from "./senderTrafficLimiter";
import type { PrometheusEndpointSuffix } from "instant-config";

export interface PrometheusSenderBody {
  action?: string;
  duration?: number;
}

declare let window: Window & {
  ads: FandomLegacyAds;
};

export function send(
  endpoint: PrometheusEndpointSuffix,
  senderBody: PrometheusSenderBody,
): void {
  if (!shouldSendToEndpoint(endpoint)) {
    return;
  }

  const serviceEndpoint = [
    getServiceTrackingUrl(),
    "adeng",
    "api",
    "adengine",
    "meter",
    endpoint,
  ].join("/");
  const appName = (window?.ads?.context?.platform || "fandom") + "_odyssey";

  const searchParams = new URLSearchParams(Object.entries(senderBody));

  fetchTimeout(
    `${serviceEndpoint}?app=${appName}&${searchParams.toString()}`,
    TRACKING_FETCH_TIMEOUT,
    {
      mode: "no-cors",
    },
  ).catch((e) => console.warn("Failed to send adengine metrics", e));
}
